import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBIcon } from "mdbreact";
import { SetSELECTED } from "../../../../../../../services/redux/slices/commerce/pos/services/taskGenerator";
import { Services } from "../../../../../../../services/fakeDb";
import PreAnalytical from "./preAnalytical";
import Requests from "./requests";

const PrimaryFooter = ({ deal }) => {
  const { activePlatform } = useSelector(({ auth }) => auth);
  const { rendered = [], cart = [] } = deal;
  const dispatch = useDispatch();

  const department = activePlatform.department === "Laboratory" ? "LAB" : "RAD";

  const [showPreAnalytical, setShowPreAnalytical] = useState(false),
    [showRequests, setShowRequests] = useState(false),
    // supplies recorded for this patient: deal.hasDispense and deal.dispensed
    // (the _id of its Expenses logs), updated on save
    [dispensed, setDispensed] = useState({
      hasDispense: !!deal.hasDispense,
      dispensed: deal.dispensed || [],
    });

  useEffect(() => {
    setDispensed({
      hasDispense: !!deal.hasDispense,
      dispensed: deal.dispensed || [],
    });
  }, [deal.hasDispense, deal.dispensed]);

  const { dept } =
    rendered?.find(
      ({ dept }) =>
        dept === (activePlatform.department === "Laboratory" ? "LAB" : "RAD"),
    ) || {};

  const handlePrintOut = (isResult = false) => {
    const list = cart?.flatMap((item) => item.packages || []);
    const _inhouse = Services.whereIn(list);
    const inhouseIDS = _inhouse.map(({ id }) => id);
    const forms = Services.getTemplates(inhouseIDS, department);

    localStorage.setItem("inhouse", JSON.stringify({ deal, forms, isResult }));
    window.open(
      "/printout/request/form",
      "RequestForm",
      "top=100px,left=100px,width=400px,height=750px",
    );
  };

  return (
    <>
      <div className="onb-actions">
        <button
          type="button"
          onClick={() => setShowPreAnalytical(true)}
          className={`onb-btn ${dispensed.hasDispense ? "green" : "purple"}`}
          style={{ position: "relative" }}
          title={
            dispensed.hasDispense
              ? `Supplies dispensed${
                  dispensed.units ? ` (${dispensed.units} unit(s))` : ""
                } · ${dispensed.dispensed?.length || 0} expense log(s)`
              : "Pre-Analytical Supplies: not dispensed yet"
          }
        >
          <MDBIcon icon="flask" />
          {dispensed.hasDispense && (
            <MDBIcon
              icon="check-circle"
              className="white-text"
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                fontSize: "0.75rem",
                background: "#2e7d32",
                borderRadius: "50%",
              }}
            />
          )}
        </button>
        <button
          type="button"
          onClick={() => setShowRequests(true)}
          className="onb-btn blue"
          title="Requested Services"
        >
          <MDBIcon icon="list" />
        </button>
        {dept && (
          <>
            <button
              type="button"
              onClick={() => handlePrintOut(false)}
              className="onb-btn dark"
              title="Print Barcode"
            >
              <MDBIcon icon="barcode" />
            </button>
            <button
              type="button"
              onClick={() => handlePrintOut(true)}
              className="onb-btn dark"
              title="Print Result Notes"
            >
              <MDBIcon icon="print" />
            </button>
          </>
        )}
        <button
          type="button"
          onClick={() => dispatch(SetSELECTED(deal))}
          className="onb-btn green"
          title="Generate Task"
        >
          <MDBIcon icon="play" />
        </button>
      </div>
      <PreAnalytical
        show={showPreAnalytical}
        toggle={() => setShowPreAnalytical(false)}
        deal={deal}
        department={department}
        onSaved={(result) => result && setDispensed(result)}
      />
      <Requests
        show={showRequests}
        toggle={() => setShowRequests(false)}
        deal={deal}
        department={department}
        isRendered={!!dept}
        onPrint={handlePrintOut}
      />
    </>
  );
};

export default PrimaryFooter;
